// extracted by mini-css-extract-plugin
var _1 = "CourseSearch_fluid__d3461";
var _2 = "CourseSearch_prefixWrapper__81b6c";
var _3 = "CourseSearch_root__602c5";
export { _1 as "fluid", _2 as "prefixWrapper", _3 as "root" }
